import React, {memo} from "react";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {HashLink as Link} from 'react-router-hash-link';
import RatingBox from "./RatingBox.js";
import Helper from "../functions/Helper.js";

function ShoeListRow(props) {

  let {shoe, expanded} = props;
  let dateParts = shoe.release_date.split("-");
  let jsDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2].substr(0, 2), dateParts[2].substr(3, 2), dateParts[2].substr(6, 2), dateParts[2].substr(9, 2));
  let second_row = expanded
    ? "display_yes"
    : "display_no";


  return (<div style={{
      width: "100%"
    }}>

    <Col xs={12}>
      <Row className="odd_row">
        <Col style={{
            padding: 0,
            display: "flex"
          }} xs={12} lg={4}>
          <RatingBox rating={props.userRating ? shoe.user_rating : shoe.rating} reviews={props.userRating ? shoe.user_review_amount : shoe.review_amount}/>
          <div style={{
              flex: 1,
              paddingLeft: 15
            }} className="table_cell first_row">
            <Link className="shoe_name thg_header" to={"/shoe-reviews/" + shoe.url.toLowerCase() + "/"}>
              {shoe.shoe_name}
              {
                props.fav && <i style={{
                      marginLeft: 10,
                      color: "orange"
                    }} className="fas fa-star"></i>
              }
            </Link>
          </div>
          <div style={{
              cursor: "pointer",
              fontSize: 20,
              width: 40
            }} onClick={() => {
              props.expand({id: shoe.shoe_id});
            }} className="table_cell no_padding justify_center first_row show_more">
            {
              props.expanded
                ? <i className="fa fa-chevron-circle-up"></i>
                : <i className="fa fa-chevron-circle-down"></i>
            }
          </div>
        </Col>
        <Col className={"no_padding table_cell justify_center  " + second_row} xs={3} lg={1}>

          <div className="cell_header outdoor_header">Release</div>
          <div className="outdoor_text">
            {jsDate.getMonth() + 1}/{jsDate.getFullYear()}
          </div>

        </Col>
        <Col className={"no_padding table_cell justify_center price " + second_row} xs={3} lg={1}>
          {
            shoe.discount < shoe.price
              ? <Link scroll={el => el.scrollIntoView({behavior: 'smooth', block: 'start'})} to={"/shoe-reviews/" + shoe.url.toLowerCase() + "/#comparison"} className="link no_padding table_cell justify_center price">
                  <span className="discount">
                    ${shoe.discount}
                  </span>
                  <span className="old_price">
                    ${Math.round(shoe.price)}
                  </span>
                </Link>

              : <Link scroll={el => el.scrollIntoView({behavior: 'smooth', block: 'start'})} to={"/shoe-reviews/" + shoe.url.toLowerCase() + "/#comparison"} className={"link no_padding table_cell justify_center price  " + second_row}>
                  <span className="price">
                    ${Math.round(shoe.price)}
                  </span>
                </Link>
          }
        </Col>
        <Col className={"no_padding table_cell justify_center  " + second_row} xs={3} lg={{
            span: 1,
            order: 2
          }}>
          <Link scroll={el => el.scrollIntoView({behavior: 'smooth', block: 'start'})} className="link  table_cell justify_center" to={"/shoe-reviews/" + shoe.url + "/#Outdoor"}>
            <div className="cell_header outdoor_header">Outdoor</div>
            <div className="outdoor_text" style={{color:Helper.get_color(props.userRating ? shoe.user_outdoor : shoe.outdoor,"outdoor"),fontSize:13,fontWeight:"bold"}}>
              {Helper.getOutdoorDescription(props.userRating ? shoe.user_outdoor : shoe.outdoor)}
            </div>
          </Link>

        </Col>
        <Col className={"no_padding table_cell justify_center  " + second_row} xs={3} lg={1}>
          <Link scroll={el => el.scrollIntoView({behavior: 'smooth', block: 'start'})} className="link table_cell justify_center" to={"/shoe-reviews/" + shoe.url + "/#Traction"}>
            <div className="cell_header">Traction</div>
            <div>
              <div className="rating_text" style={{
                  color: Helper.get_color(props.userRating ? shoe.user_traction : shoe.traction, "text")
                }}>
                {Helper.printRating(props.userRating ? shoe.user_traction : shoe.traction, 1)}
              </div>
            </div>
          </Link>
        </Col>
        <Col className={"no_padding table_cell justify_center  " + second_row} xs={3} lg={1}>
          <Link scroll={el => el.scrollIntoView({behavior: 'smooth', block: 'start'})} className="link table_cell justify_center" to={"/shoe-reviews/" + shoe.url + "/#Cushion"}>
            <div className="cell_header">Cushion</div>
            <div className="rating_text" style={{
                color: Helper.get_color(props.userRating ? shoe.user_cushion: shoe.cushion, "text")
              }}>
              {Helper.printRating(props.userRating ? shoe.user_cushion : shoe.cushion , 1)}
            </div>
          </Link>
        </Col>
        <Col className={"no_padding table_cell justify_center  " + second_row} xs={3} lg={1}>
          <Link scroll={el => el.scrollIntoView({behavior: 'smooth', block: 'start'})} className="link table_cell justify_center" to={"/shoe-reviews/" + shoe.url + "/#Material"}>
            <div className="cell_header">Materials</div>
            <div className="rating_text" style={{
                color: Helper.get_color(props.userRating ? shoe.user_materials : shoe.materials, "text")
              }}>
              {Helper.printRating(props.userRating ? shoe.user_materials : shoe.materials, 1)}
            </div>
          </Link>
        </Col>
        <Col className={"no_padding table_cell justify_center  " + second_row} xs={3} lg={1}>
          <Link scroll={el => el.scrollIntoView({behavior: 'smooth', block: 'start'})} className="link table_cell justify_center" to={"/shoe-reviews/" + shoe.url + "/#Support"}>
            <div className="cell_header">Support</div>
            <div className="rating_text" style={{
                color: Helper.get_color(props.userRating ? shoe.user_support : shoe.support, "text")
              }}>
              {Helper.printRating(props.userRating ? shoe.user_support : shoe.support, 1)}
            </div>

          </Link>
        </Col>
        <Col className={"no_padding table_cell justify_center  " + second_row} xs={3} lg={1}>
          <Link scroll={el => el.scrollIntoView({behavior: 'smooth', block: 'start'})} className="link table_cell justify_center" to={"/shoe-reviews/" + shoe.url + "/#Fit"}>
            <div className="cell_header">Fit</div>
            <div className="rating_text" style={{
                color: Helper.get_color(props.userRating ? shoe.user_fit : shoe.fit, "text")
              }}>
              {Helper.printRating(props.userRating ? shoe.user_fit : shoe.fit, 1)}
            </div>

          </Link>
        </Col>
      </Row>
    </Col>
  </div>);
}

export default memo(ShoeListRow);
